/**
 * Utility for emitting custom events from components.
 * @param element Element dispatching the event. Usually set to `this`.
 * @param eventName Name of the custom event.
 * @param composed Whether the event should propagate through shadow roots. If false, it will only bubble to the immediate parent.
 * @param detail Payload to add to the event.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function emit(element: HTMLElement, eventName: string, composed = false, detail?: any) {
  element.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true, composed }))
}
